export class FiltroActividades{
    numberOT:number;
    dateFrom:Date;
    dateUntil:Date;
    code:string;
    name:string;
    section:string;
    frequency:string;
    state:String;
    orderWhen:String="down";
}